
      // Import the functions you need from the SDKs you need
      import { initializeApp } from "https://www.gstatic.com/firebasejs/12.19.0/firebase-app.js";
      import { getAnalytics } from "https://www.gstatic.com/firebasejs/12.19.0/firebase-analytics.js";
      // TODO: Add SDKs for Firebase products that you want to use
      // https://firebase.google.com/docs/web/setup#available-libraries

      // Your web app's Firebase configuration
      // For Firebase JS SDK v7.20.0 and later, measurementId is optional
      const firebaseConfig = {
        apiKey: "AIzaSyDWmf7DdDnbMBTsD4j0nXH0-3Wfu5q2dOM",
        authDomain: "kantiro-a1fb7.firebaseapp.com",
        projectId: "kantiro-a1fb7",
        storageBucket: "kantiro-a1fb7.firebasestorage.app",
        messagingSenderId: "108357674162",
        appId: "1:108357674162:web:7db5c6aa012689ec0d95ab",
        measurementId: "G-YDRP9Q2H77"
      };

      // Initialize Firebase
      const app = initializeApp(firebaseConfig);
      const analytics = getAnalytics(app);
    